export { default as pageInstanceId, getStaticId, resetStaticId, getRandomId } from './pageInstanceId';